<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="店铺分销" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="main-content">
        <div  @click="goSellerInviterGoodsList">
        <flex-line :is-link="true" :show-border="true"><span class="line-name">分销商品管理</span></flex-line>
        </div>
        <div  @click="goSellerInviterOrderList">
        <flex-line :is-link="true" :show-border="true"><span class="line-name">分销业绩</span></flex-line>
        </div>
        </div>
    </div>
</template>

<script>
import flexLine from '../../flexLine'
export default {
  name: 'Index',
    components:{flexLine,},
  methods: {
    goSellerInviterGoodsList () {
      this.$router.push({ name: 'SellerInviterGoodsList' })
    },
    goSellerInviterOrderList () {
      this.$router.push({ name: 'SellerInviterOrderList' })
    }
  }
}
</script>

<style scoped lang="scss">
.main-content{background: #fff;padding:0 $pageSpace}

</style>
